import { addressDef } from "./address-def";

export const permanentAddressDialogDef = {
  type: "permanentAddress",
  dialogLabel: "MY_HR_EDIT_PERMANENT_ADDRESS",
  ...addressDef(),
};
